var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllGames = function SvgIllGames(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 126,
    viewBox: "0 0 367 126",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 1010,
    r: 1000,
    fill: "#F6D703"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.764 26.7846L277.656 27.3196L291.215 27.4057L285.857 26.5625L274.764 26.7846Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.677 5.44238L287.629 15.2614C287.629 15.2614 291.042 16.4763 292.783 11.8977C293.635 7.63195 291.677 5.44238 291.677 5.44238Z",
    fill: "#ED1B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.452 0.963522C272.452 0.963522 282.063 1.53471 289.212 3.49309L284.815 14.0873L269.098 10.9231C269.098 10.9231 270.816 4.84853 272.457 0.958985L272.452 0.963522Z",
    fill: "#0066FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.059 10.2666L261.867 25.308L277.634 27.1167L286.315 27.1167L286.315 13.3175L278.046 12.4879L263.059 10.2666Z",
    fill: "#F6D638",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.806 10.6738L276.822 12.3058L275.789 26.9029L264.791 25.6427L265.806 10.6738Z",
    fill: "#ED1B98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283.998 13.0862L283.785 27.1167L279.633 27.1167L280.263 12.71L283.998 13.0862Z",
    fill: "#ED1B98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.223 16.533C273.403 15.1199 272.689 13.8648 271.629 13.7297C270.568 13.5946 269.563 14.6306 269.383 16.0438C269.203 17.4569 269.916 18.7121 270.977 18.8472C272.037 18.9823 273.043 17.9462 273.223 16.533Z",
    fill: "#F6D638"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.186 14.3594C271.186 14.3594 270.012 14.713 269.998 16.286C269.985 17.8591 270.637 18.1582 271.05 18.2353C271.05 18.2353 271.725 18.4892 272.129 17.6641",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.212 3.49316L291.678 5.44247L287.63 15.2615L284.814 14.0919L289.212 3.49316Z",
    fill: "#F6D638"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.466 4.62737C280.466 4.62737 279.836 -0.146154 283.83 0.00344431C287.823 0.153042 286.695 5.38442 284.569 6.14601C284.569 6.14601 282.982 6.7172 282.569 7.85505L280.593 7.18866C280.593 7.18866 280.724 5.64736 280.461 4.62737L280.466 4.62737Z",
    fill: "#F6D638"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M277.889 12.4655L279.629 8.90234L281.932 9.84526L280.636 12.7103L277.889 12.4655Z",
    fill: "#F6D638"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.338 8.56561L283.402 10.6464C283.447 10.6645 283.493 10.6781 283.543 10.6872C283.824 10.728 284.749 10.7914 285.093 9.83945C285.506 8.71067 284.241 8.32988 284.241 8.32988L279.173 6.3579C279.014 6.29444 278.833 6.29897 278.678 6.3715C278.438 6.48937 278.103 6.74323 277.94 7.26909C277.754 7.86295 277.958 8.23015 278.103 8.40241C278.166 8.47494 278.243 8.52934 278.329 8.56107L278.338 8.56561Z",
    fill: "#F6D638"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.613 6.92141L282.635 7.7102L280.622 6.64941",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M278.232 8.5127L283.464 10.7113",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.119 9.96259L279.509 9.04688L281.05 9.84473L279.477 9.64526L280.565 10.1757",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M264.709 10.8462L264.397 3.33459C264.392 3.18499 264.533 3.07166 264.678 3.11246C265.226 3.25299 266.477 3.79698 267.851 5.94575L272.652 2.79513C272.806 2.69086 273.019 2.77247 273.069 2.94927L274.483 7.96759L277.616 5.90495C277.743 5.81882 277.91 5.93215 277.883 6.08175L276.682 12.5144L264.705 10.8462L264.709 10.8462Z",
    fill: "#F6D638"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M264.396 5.44238L267.588 8.2938L271.604 5.98637L274.225 10.2658L277.371 8.83326",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M267.856 15.9247C268.637 15.9247 269.27 15.3037 269.27 14.5376C269.27 13.7715 268.637 13.1504 267.856 13.1504C267.075 13.1504 266.441 13.7715 266.441 14.5376C266.441 15.3037 267.075 15.9247 267.856 15.9247Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M270.971 12.7098C271.789 12.7098 272.453 12.0684 272.453 11.2772C272.453 10.4861 271.789 9.84473 270.971 9.84473C270.152 9.84473 269.488 10.4861 269.488 11.2772C269.488 12.0684 270.152 12.7098 270.971 12.7098Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M269.27 13.2216C269.936 13.2216 270.476 12.629 270.476 11.8979C270.476 11.1669 269.936 10.5742 269.27 10.5742C268.604 10.5742 268.064 11.1669 268.064 11.8979C268.064 12.629 268.604 13.2216 269.27 13.2216Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.5 19.1816C268.274 19.1816 268.901 18.5321 268.901 17.7309C268.901 16.9297 268.274 16.2803 267.5 16.2803C266.727 16.2803 266.1 16.9297 266.1 17.7309C266.1 18.5321 266.727 19.1816 267.5 19.1816Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M266.899 22.2028C267.69 22.2028 268.332 21.598 268.332 20.8519C268.332 20.1058 267.69 19.501 266.899 19.501C266.108 19.501 265.467 20.1058 265.467 20.8519C265.467 21.598 266.108 22.2028 266.899 22.2028Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M266.262 25.0227C266.995 25.0227 267.59 24.428 267.59 23.6945C267.59 22.9609 266.995 22.3662 266.262 22.3662C265.528 22.3662 264.934 22.9609 264.934 23.6945C264.934 24.428 265.528 25.0227 266.262 25.0227Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M264.385 27.1163C265.074 27.1163 265.632 26.5155 265.632 25.7745C265.632 25.0334 265.074 24.4326 264.385 24.4326C263.697 24.4326 263.139 25.0334 263.139 25.7745C263.139 26.5155 263.697 27.1163 264.385 27.1163Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M260.031 26.0028C260.684 26.0028 261.214 25.4325 261.214 24.7289C261.214 24.0254 260.684 23.4551 260.031 23.4551C259.377 23.4551 258.848 24.0254 258.848 24.7289C258.848 25.4325 259.377 26.0028 260.031 26.0028Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M261.968 28.2317C262.689 28.2317 263.273 27.6086 263.273 26.84C263.273 26.0713 262.689 25.4482 261.968 25.4482C261.247 25.4482 260.662 26.0713 260.662 26.84C260.662 27.6086 261.247 28.2317 261.968 28.2317Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M262.148 24.4916C262.769 24.4916 263.272 23.9599 263.272 23.3039C263.272 22.648 262.769 22.1162 262.148 22.1162C261.527 22.1162 261.023 22.648 261.023 23.3039C261.023 23.9599 261.527 24.4916 262.148 24.4916Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1992 33.602L97.7885 33.602L89.1206 32.6328L85.1992 33.602Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0198 33.602C91.5535 33.602 96.0395 29.116 96.0395 23.5823C96.0395 18.0485 91.5535 13.5625 86.0198 13.5625C80.486 13.5625 76 18.0485 76 23.5823C76 29.116 80.486 33.602 86.0198 33.602Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9064 19.9346C78.9721 19.9992 76 23.5777 76 23.5777C76.4722 32.5935 84.6828 33.508 84.6828 33.508C86.487 25.4415 91.0595 22.4693 91.0595 22.4693L89.9064 19.9346V19.9346Z",
    fill: "#ED1B98"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8867 14.4528C81.8867 14.4528 86.7425 15.6655 89.9085 19.9348C89.9085 19.7658 92.9204 20.0541 92.9204 20.0541C92.9204 20.0541 92.3936 16.7191 90.8429 14.7907C90.8429 14.7907 86.5835 12.3255 81.8867 14.4478L81.8867 14.4528Z",
    fill: "#ED1B98"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M93.146 30.625C93.146 30.625 93.7872 24.5217 91.0586 22.474L91.9135 19.8994C91.9135 19.8994 94.7415 19.636 95.8647 21.7136C95.8647 21.7136 97.2066 26.7483 93.146 30.6299L93.146 30.625Z",
    fill: "#ED1B98"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0979 22.502C92.9334 22.2053 93.3263 21.1638 92.9754 20.1757C92.6245 19.1876 91.6627 18.6271 90.8273 18.9237C89.9918 19.2204 89.5989 20.262 89.9498 21.2501C90.3007 22.2382 91.2624 22.7987 92.0979 22.502Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 40.8275C24.5512 40.8275 24.4789 40.2232 23.3056 39.8495C22.1323 39.4758 19.8936 38.4605 20.948 37.0884C20.948 37.0884 21.6661 36.4692 22.3204 37.6175C22.9747 38.7658 23.4086 39.1199 23.3199 38.8418C23.2312 38.5637 22.7961 37.8853 22.2864 36.607C21.7767 35.3287 20.7039 33.2451 22.073 32.2651C23.4421 31.2851 23.8733 33.4383 23.6334 34.1276C23.3936 34.8169 23.1169 35.8024 23.2433 36.4734C23.3696 37.1444 23.5394 38.3633 23.5209 37.9278C23.5025 37.4923 23.3955 37.2711 23.5379 36.3794C23.6257 35.808 23.9297 35.4229 24.6026 35.5658C25.2756 35.7087 25.212 37.3741 24.585 38.3363C23.9579 39.2986 25.2146 39.9339 25.2596 40.1894C25.3046 40.445 25.7341 40.7166 24.5468 40.8253L24.5512 40.8275Z",
    fill: "#32BF5E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.729 58.1193C239.729 58.1193 240.766 58.3122 241.308 57.3679C241.849 56.4236 242.271 56.5689 242.456 55.3341C242.641 54.0992 242.327 53.8788 241.849 53.9815C241.371 54.0842 240.88 54.8907 240.88 56.5739C240.824 56.8895 240.735 57.0924 240.74 57.0698C240.785 56.8795 241.03 55.5695 240.336 54.4198C239.808 53.5457 238.973 52.7667 238.321 53.1274C237.669 53.4881 238.284 54.4273 239.15 55.5745C239.15 55.5745 240.558 57.1074 240.286 57.398C240.014 57.6885 239.734 58.1193 239.734 58.1193L239.729 58.1193Z",
    fill: "#32BF5E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04141 120.731C7.04141 120.731 8.54288 120.054 8.33317 118.301C8.12347 116.549 8.7982 116.363 7.85958 114.543C6.92096 112.722 6.31236 112.71 5.80284 113.279C5.29331 113.847 5.43583 115.37 7.03528 117.624C7.26475 118.096 7.34351 118.449 7.32879 118.414C7.20492 118.119 6.27203 116.143 4.29739 115.229C2.79588 114.535 0.995738 114.244 0.509992 115.315C0.024247 116.386 1.69833 117.089 3.88861 117.844C3.88861 117.844 7.13305 118.629 7.06366 119.263C6.99428 119.897 7.04813 120.726 7.04813 120.726L7.04141 120.731Z",
    fill: "#32BF5E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M335.752 45.4786L334.559 47.0501C334.516 47.1275 334.515 47.2156 334.555 47.291L335.299 48.7056C335.398 48.8958 335.225 49.1187 335.004 49.0861L333.367 48.8246C333.278 48.8096 333.19 48.8378 333.124 48.9006L331.811 50.3622C331.651 50.516 331.38 50.4323 331.355 50.2197L331.271 48.3257C331.261 48.242 331.206 48.169 331.128 48.1296L329.094 47.2784C328.894 47.1855 328.899 46.9081 329.104 46.8117L331.172 46.2463C331.252 46.2093 331.309 46.1344 331.323 46.0487L331.602 44.4632C331.639 44.2491 331.914 44.1634 332.068 44.3152L333.206 45.4562C333.268 45.5179 333.355 45.5462 333.443 45.5296L335.475 45.0986C335.697 45.063 335.862 45.282 335.751 45.4752L335.752 45.4786Z",
    fill: "#2FCDF2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8419 44.4748C50.9897 44.4748 51.1096 44.355 51.1096 44.2071C51.1096 44.0593 50.9897 43.9395 50.8419 43.9395C50.6941 43.9395 50.5742 44.0593 50.5742 44.2071C50.5742 44.355 50.6941 44.4748 50.8419 44.4748Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8212 45.1561C51.9144 45.1561 51.99 45.0805 51.99 44.9872C51.99 44.894 51.9144 44.8184 51.8212 44.8184C51.7279 44.8184 51.6523 44.894 51.6523 44.9872C51.6523 45.0805 51.7279 45.1561 51.8212 45.1561Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8607 76.0281C50.0427 76.0281 50.1902 75.8805 50.1902 75.6986C50.1902 75.5166 50.0427 75.3691 49.8607 75.3691C49.6788 75.3691 49.5312 75.5166 49.5312 75.6986C49.5312 75.8805 49.6788 76.0281 49.8607 76.0281Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0188 74.0865C49.1371 74.0865 49.233 73.9906 49.233 73.8723C49.233 73.7541 49.1371 73.6582 49.0188 73.6582C48.9006 73.6582 48.8047 73.7541 48.8047 73.8723C48.8047 73.9906 48.9006 74.0865 49.0188 74.0865Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8036 77.3737C28.0219 77.3737 28.1989 77.1967 28.1989 76.9784C28.1989 76.76 28.0219 76.583 27.8036 76.583C27.5852 76.583 27.4082 76.76 27.4082 76.9784C27.4082 77.1967 27.5852 77.3737 27.8036 77.3737Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M19.577 102.05C19.7953 102.05 19.9723 101.873 19.9723 101.655C19.9723 101.437 19.7953 101.26 19.577 101.26C19.3586 101.26 19.1816 101.437 19.1816 101.655C19.1816 101.873 19.3586 102.05 19.577 102.05Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6444 66.5399C90.9011 66.5399 91.1092 66.3318 91.1092 66.0751C91.1092 65.8184 90.9011 65.6104 90.6444 65.6104C90.3878 65.6104 90.1797 65.8184 90.1797 66.0751C90.1797 66.3318 90.3878 66.5399 90.6444 66.5399Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8858 64.3313C92.086 64.3313 92.2483 64.169 92.2483 63.9689C92.2483 63.7687 92.086 63.6064 91.8858 63.6064C91.6857 63.6064 91.5234 63.7687 91.5234 63.9689C91.5234 64.169 91.6857 64.3313 91.8858 64.3313Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M111.915 22.969C112.115 22.969 112.278 22.8067 112.278 22.6065C112.278 22.4064 112.115 22.2441 111.915 22.2441C111.715 22.2441 111.553 22.4064 111.553 22.6065C111.553 22.8067 111.715 22.969 111.915 22.969Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.754 24.3869C112.902 24.3869 113.022 24.2671 113.022 24.1193C113.022 23.9714 112.902 23.8516 112.754 23.8516C112.606 23.8516 112.486 23.9714 112.486 24.1193C112.486 24.2671 112.606 24.3869 112.754 24.3869Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.133 22.8979C120.24 22.8979 120.327 22.8112 120.327 22.7043C120.327 22.5974 120.24 22.5107 120.133 22.5107C120.026 22.5107 119.939 22.5974 119.939 22.7043C119.939 22.8112 120.026 22.8979 120.133 22.8979Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M193.565 75.349C193.672 75.349 193.758 75.2624 193.758 75.1555C193.758 75.0486 193.672 74.9619 193.565 74.9619C193.458 74.9619 193.371 75.0486 193.371 75.1555C193.371 75.2624 193.458 75.349 193.565 75.349Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M137.781 50.0971C137.888 50.0971 137.975 50.0104 137.975 49.9035C137.975 49.7966 137.888 49.71 137.781 49.71C137.675 49.71 137.588 49.7966 137.588 49.9035C137.588 50.0104 137.675 50.0971 137.781 50.0971Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M120.133 22.8979C120.24 22.8979 120.327 22.8112 120.327 22.7043C120.327 22.5974 120.24 22.5107 120.133 22.5107C120.026 22.5107 119.939 22.5974 119.939 22.7043C119.939 22.8112 120.026 22.8979 120.133 22.8979Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M150.406 22.2807C150.513 22.2807 150.6 22.194 150.6 22.0871C150.6 21.9802 150.513 21.8936 150.406 21.8936C150.3 21.8936 150.213 21.9802 150.213 22.0871C150.213 22.194 150.3 22.2807 150.406 22.2807Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M242.084 37.6701C242.315 37.6701 242.503 37.4823 242.503 37.2506C242.503 37.0189 242.315 36.8311 242.084 36.8311C241.852 36.8311 241.664 37.0189 241.664 37.2506C241.664 37.4823 241.852 37.6701 242.084 37.6701Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M224.87 23.0013C225.065 23.0013 225.224 22.8427 225.224 22.6471C225.224 22.4515 225.065 22.293 224.87 22.293C224.674 22.293 224.516 22.4515 224.516 22.6471C224.516 22.8427 224.674 23.0013 224.87 23.0013Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M263.886 68.0939C264.118 68.0939 264.306 67.9061 264.306 67.6744C264.306 67.4427 264.118 67.2549 263.886 67.2549C263.655 67.2549 263.467 67.4427 263.467 67.6744C263.467 67.9061 263.655 68.0939 263.886 68.0939Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M293.437 40.6208C293.603 40.6208 293.738 40.4862 293.738 40.3202C293.738 40.1541 293.603 40.0195 293.437 40.0195C293.271 40.0195 293.137 40.1541 293.137 40.3202C293.137 40.4862 293.271 40.6208 293.437 40.6208Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M297.541 40.6326C297.671 40.6326 297.776 40.5275 297.776 40.3978C297.776 40.2682 297.671 40.1631 297.541 40.1631C297.412 40.1631 297.307 40.2682 297.307 40.3978C297.307 40.5275 297.412 40.6326 297.541 40.6326Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M304.323 76.6121C304.452 76.6121 304.557 76.507 304.557 76.3773C304.557 76.2477 304.452 76.1426 304.323 76.1426C304.193 76.1426 304.088 76.2477 304.088 76.3773C304.088 76.507 304.193 76.6121 304.323 76.6121Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M320.757 60.5514C320.975 60.5514 321.152 60.3744 321.152 60.1561C321.152 59.9377 320.975 59.7607 320.757 59.7607C320.538 59.7607 320.361 59.9377 320.361 60.1561C320.361 60.3744 320.538 60.5514 320.757 60.5514Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M357.77 97.5671C357.989 97.5671 358.166 97.3901 358.166 97.1717C358.166 96.9534 357.989 96.7764 357.77 96.7764C357.552 96.7764 357.375 96.9534 357.375 97.1717C357.375 97.3901 357.552 97.5671 357.77 97.5671Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M353.659 122.246C353.877 122.246 354.054 122.069 354.054 121.85C354.054 121.632 353.877 121.455 353.659 121.455C353.441 121.455 353.264 121.632 353.264 121.85C353.264 122.069 353.441 122.246 353.659 122.246Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M312.53 105.794C312.748 105.794 312.925 105.617 312.925 105.398C312.925 105.18 312.748 105.003 312.53 105.003C312.312 105.003 312.135 105.18 312.135 105.398C312.135 105.617 312.312 105.794 312.53 105.794Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8746 72.5677C71.6237 73.6658 71.0068 74.5707 69.7483 74.7434C69.4892 74.7804 69.263 74.7352 69.0326 74.8791C68.6872 75.0971 68.5144 75.7305 68.0661 75.6811C67.3505 75.603 65.6806 74.8956 65.4421 74.3979C65.2611 74.0236 65.6683 73.7645 65.586 73.3286C65.5531 73.1435 65.512 73.0407 65.4133 72.8844C65.0555 72.3086 64.9115 71.6505 65.0596 71.0048C65.4051 69.4913 67.2147 68.6152 69.0984 69.043C70.9821 69.4707 72.2283 71.05 71.8787 72.5636L71.8746 72.5677Z",
    fill: "#FCAEE0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1094 73.3369L68.1576 74.5708",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3203 70.9551L66.6164 73.6449",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8965 73.8141L69.0023 70.0508",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M67.252 73.9544C67.3712 73.8434 67.3424 73.8722 70.4518 71.499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4766 74.1637L69.9936 73.6455",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M268.124 43.0538C269.035 43.4247 269.67 43.9829 269.465 44.7906C269.424 44.957 269.316 45.0888 269.382 45.2587C269.476 45.5117 269.999 45.744 269.822 46.0144C269.545 46.4374 268.436 47.3284 267.919 47.3769C267.534 47.415 267.416 47.1134 267 47.0787C266.824 47.0649 266.72 47.0683 266.553 47.0961C265.933 47.2036 265.302 47.162 264.764 46.9435C263.506 46.4305 263.239 45.1443 264.164 44.0695C265.094 42.9948 266.865 42.5372 268.124 43.0503L268.124 43.0538Z",
    fill: "#FCAEE0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M267.156 46.759L268.852 45.7363",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M265.08 46.1572L267.58 46.5039",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M267.811 46.3647L265.041 44.3262",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M268.037 46.1781C267.971 46.0811 267.988 46.1053 266.754 43.7236",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M268.291 46.0765L268.548 44.4229",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M125.678 56.8007C126.06 57.3107 126.217 57.8988 125.801 58.4828C125.715 58.6021 125.608 58.6802 125.579 58.8283C125.538 59.0504 125.752 59.3548 125.55 59.5234C125.234 59.7907 124.271 60.2226 123.959 60.1362C123.724 60.0745 123.77 59.8113 123.543 59.6838C123.449 59.6303 123.387 59.6098 123.28 59.5892C122.885 59.5234 122.54 59.3424 122.314 59.0422C121.783 58.3389 122.108 57.2695 123.033 56.6485C123.959 56.0274 125.143 56.0932 125.674 56.7965L125.678 56.8007Z",
    fill: "#FCAEE0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M123.752 59.4739L125.101 59.0791",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M122.729 58.4629L124.09 59.3759",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M124.276 59.321L123.412 57.4209",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.473 59.2267C124.473 59.1362 124.473 58.9964 124.65 56.833",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M124.656 59.2114L125.413 57.9775",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M365.799 121.868C366.181 122.378 366.338 122.966 365.922 123.55C365.836 123.669 365.729 123.748 365.7 123.896C365.659 124.118 365.873 124.422 365.671 124.591C365.355 124.858 364.392 125.29 364.08 125.204C363.845 125.142 363.891 124.879 363.664 124.751C363.57 124.698 363.508 124.677 363.401 124.657C363.006 124.591 362.661 124.41 362.435 124.11C361.904 123.406 362.229 122.337 363.154 121.716C364.08 121.095 365.264 121.161 365.795 121.864L365.799 121.868Z",
    fill: "#FCAEE0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M363.875 124.541L365.224 124.146",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M362.85 123.529L364.211 124.442",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M364.397 124.388L363.533 122.488",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M364.594 124.295C364.594 124.205 364.594 124.065 364.771 121.901",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M364.777 124.279L365.534 123.045",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllGames, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_games.ab55d33d.svg";
export { ForwardRef as ReactComponent };